import { Actions } from './focus-observer.actions';
import { SET_FOCUS } from './focus-observer.constants';

export const initialState: boolean = false;

export const reducerKey = 'hasFocus' as const;

export const FocusObserver = (state: boolean = initialState, action: Actions): boolean => {
    switch (action.type) {
    case SET_FOCUS:
        return action.payload;
    default:
        return state;
    }
};

export default FocusObserver;
